import { render, staticRenderFns } from "./aiWatchingPolice.vue?vue&type=template&id=233b6338&scoped=true"
import script from "./aiWatchingPolice.vue?vue&type=script&lang=ts"
export * from "./aiWatchingPolice.vue?vue&type=script&lang=ts"
import style0 from "./aiWatchingPolice.vue?vue&type=style&index=0&id=233b6338&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233b6338",
  null
  
)

export default component.exports